import { render, staticRenderFns } from "./UiIconPicker.vue?vue&type=template&id=5b2f87f8&scoped=true&"
import script from "./UiIconPicker.vue?vue&type=script&lang=js&"
export * from "./UiIconPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f87f8",
  null
  
)

export default component.exports